import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import FullWidthSlides from '@client/components/fullWidthSlides/FullWidthSlides';
import { seriesRoute } from '@client/pages/routes';
import 'react-dynamic-swiper/lib/styles.css';
import Slideshow from '@client/components/swiper/Slideshow';
import indicators from '@client/shared/js/indicators';
import styles from './slideshowSection.scss';

class SlideshowSection extends PureComponent {
  navigateTo = (link) => {
    this.props.history.push(link);
  };
  render() {
    const { className, slides, hideEpisodeCount, textBoxStyle } = this.props;
    return (
      <div
        className={
          className
            ? `${styles.slideshowSection} ${className}`
            : styles.slideshowSection
        }
      >
        <div className={styles.contentWrapper}>
          <Slideshow
            className={styles.slideShow}
            componentid="seriesslider"
            options={{
              slidesPerView: 1,
              loop: true,
              containerModifierClass: 'factuals-slideshow-container2-',
            }}
            items={slides.map((slide) => {
              return {
                itemKey: slide.id,
                component: (
                  <FullWidthSlides
                    key={slide.id}
                    slide={slide}
                    route={seriesRoute(slide.slug)}
                    hideEpisodeCount={hideEpisodeCount}
                    textBoxStyle={textBoxStyle}
                  />
                ),
              };
            })}
          />
          <div className={styles.slideShowSectionContentContainer}>
            <div className={styles.sliderNav}>
              <img
                onClick={function() {
                  document.getElementById('prev-seriesslider').click();
                }}
                className={styles.prevButton}
                src={indicators.play_icon_white}
                alt="Previous Slide"
              />
              <img
                onClick={function() {
                  document.getElementById('next-seriesslider').click();
                }}
                className={styles.nextButton}
                src={indicators.play_icon_white}
                alt="Next Slide"
              />
            </div>
          </div>
          <div className={styles.extraBackground}></div>
        </div>
      </div>
    );
  }
}

SlideshowSection.propTypes = {
  className: PropTypes.string,
  textBoxStyle: PropTypes.string,
  slides: PropTypes.array,
  history: PropTypes.object,
  hideEpisodeCount: PropTypes.bool,
};

export default withRouter(SlideshowSection);
